module.exports = __webpack_public_path__ + "img/pcBanner7.91056416.png";